"use client";

import React, { ReactNode } from "react";

import { SPACING } from "@/lib/constants/layoutConstants";

type SectionVariant = "major" | "minor";

interface SectionProps {
  /**
   * Section variant determines vertical spacing
   * - major: py-12 lg:py-16 (for major page sections)
   * - minor: py-8 lg:py-12 (for minor sections)
   */
  variant?: SectionVariant;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Children to render inside section
   */
  children: ReactNode;
}

/**
 * Reusable section wrapper with standardized spacing
 * Ensures consistent vertical spacing between sections
 */
export function Section({
  children,
  className = "",
  variant = "major",
}: SectionProps) {
  const spacingClass =
    variant === "major" ? SPACING.SECTION_MAJOR : SPACING.SECTION_MINOR;

  return (
    <section className={`${spacingClass} ${className}`}>{children}</section>
  );
}
